import type { AuthTokens, JWT } from 'aws-amplify/auth';

/** The Cognito custom-auth claims this app reads off the id token's JWT payload. */
type CognitoCustomClaims = { user_id: string; behalf_user_id?: string };

const getPayload = (tokens: AuthTokens): CognitoCustomClaims => (tokens.idToken as JWT).payload as CognitoCustomClaims;

export const getDefaultUserId = (tokens: AuthTokens): string => getPayload(tokens).user_id;

export const getUserIdFromAuthSession = (tokens: AuthTokens): string => {
  const { behalf_user_id: userId = getDefaultUserId(tokens) } = getPayload(tokens);
  return userId;
};

export const isImpersonatingUser = (tokens: AuthTokens): boolean =>
  getDefaultUserId(tokens) !== getUserIdFromAuthSession(tokens);
